class InvestorenController {
  constructor(
    $rootScope,
    $scope,
    toastr,
    emittentenService,
    $location,
    $anchorScroll
  ) {
    'ngInject';
    this.name = 'investoren';
    this.$scope = $scope;
    this.emittentenService = emittentenService;
    this.$location = $location;
    this.$anchorScroll = $anchorScroll;
    this.toastr = toastr;
    this.disabled = [false, true, true, true];
    this.forms = {};
    this.active = 0;
    this.emailChecked = true;
    this.form = {
      adresse_land: '55',
      user_type: 2,
    };
    var that = this;

    emittentenService.getCountries($rootScope.language).then(
      (result) => {
        this.countries = result;
        return result;
      },
      (response) => {
        console.error(response);
      }
    );

    emittentenService.getSegmentTags($rootScope.language).then(
      (result) => {
        this.segmentTags = result;
        return result;
      },
      (response) => {
        console.error(response);
      }
    );

    emittentenService.getInvestorTypes($rootScope.language).then(
      (result) => {
        this.investorTypes = result;
        return result;
      },
      (response) => {
        console.error(response);
      }
    );

    emittentenService.getSelectFields(6, $rootScope.language).then(
      (result) => {
        this.sizeFocus = result;
        return result;
      },
      (response) => {
        console.error(response);
      }
    );

    emittentenService.getRegionalFocus($rootScope.language).then(
      (result) => {
        this.regionalFocus = result;
        return result;
      },
      (response) => {
        console.error(response);
      }
    );

    emittentenService.getInvestmentStages($rootScope.language).then(
      (result) => {
        this.investmentStages = result;
        return result;
      },
      (response) => {
        console.error(response);
      }
    );

    emittentenService.getHeadquarters($rootScope.language).then(
      (result) => {
        this.globalOffices = result;
        return result;
      },
      (response) => {
        console.error(response);
      }
    );
  }
  checkInvestorType(indices) {
    var that = this;
    var returnValue = false;
    indices.forEach(function(value) {
      if (
        that.$scope.vm.form.teilnehmer_details_investorentyp &&
        that.$scope.vm.form.teilnehmer_details_investorentyp.indexOf(value) !==
          -1 &&
        that.$scope.vm.form.teilnehmer_details_investorentyp.length === 1
      ) {
        returnValue = true;
      }
    });

    return returnValue;
  }
  nextTab(index, data) {
    this.disabled[index] = false;
    this.active = index;
    if (index == 2) {
      data.c = 'anmeldung.Teilnehmer';

      if (this.form.teilnehmer_unternehmensname) {
        this.form.user_type = 3;
      } else {
        this.form.user_type = 2;
      }

      Object.defineProperty(
        data,
        'teilnehmer_details_investorindustriegruppe[]',
        Object.getOwnPropertyDescriptor(
          data,
          'teilnehmer_details_investorindustriegruppe'
        )
      );
      delete data['teilnehmer_details_investorindustriegruppe'];
      Object.defineProperty(
        data,
        'teilnehmer_details_investorentyp[]',
        Object.getOwnPropertyDescriptor(
          data,
          'teilnehmer_details_investorentyp'
        )
      );
      delete data['teilnehmer_details_investorentyp'];
      Object.defineProperty(
        data,
        'teilnehmer_details_regionaler_fokus[]',
        Object.getOwnPropertyDescriptor(
          data,
          'teilnehmer_details_regionaler_fokus'
        )
      );
      delete data['teilnehmer_details_regionaler_fokus'];

      this.emittentenService.setData(data).then((result) => {
        if (result && result.code) {
          this.active = 0;
          //this.toastr.error(result.msg || 'Unbekannter Fehler. Bitte später erneut versuchen und/oder an eigenkapitalforum@deutsche-boerse.com wenden. ||| Unknown Error. Please try again later and/or email to eigenkapitalforum@deutsche-boerse.com');
          this.showError = true;
          this.errMsg =
            result.msg ||
            'Unbekannter Fehler. Bitte später erneut versuchen und/oder an eigenkapitalforum@deutsche-boerse.com wenden. ||| Unknown Error. Please try again later and/or email to eigenkapitalforum@deutsche-boerse.com';
          this.$location.hash('alert');
          this.$anchorScroll();
        } else {
          this.done = true;
          this.toastr.success(
            'Die Anmeldung wurde erfolgreich abgeschickt. Eine Bestätigung wurde an ' +
              this.form.person_email +
              ' gesendet.'
          );
          this.form = {
            adresse_land: '55',
            user_type: 2,
          };
          this.disabled = [false, true];
          this.active = 0;
        }
      });
    }
  }

  checkEmail(email) {
    this.emittentenService.checkEmail(email).then(
      (result) => {
        this.emailChecked = result;
      },
      (response) => {
        console.error(response);
      }
    );
  }
}

export default InvestorenController;



// WEBPACK FOOTER //
// ./client/app/common/forms/investoren/investoren.controller.js